import fetchNormal, {
  reqOpenIdConfigGET
} from './ssohandy-req-config.mjs';

const reqTokenGrantAuthCodePOST = async ( opts, code, verifier ) => (
  fetchNormal( ( await reqOpenIdConfigGET( opts ) ).token_endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    ...( opts.credentials && { credentials: opts.credentials }),
    body: JSON.stringify({
      code: code,
      redirect_uri: opts.redirect_uri,
      code_verifier: verifier,
      client_id: opts.client_id,
      scope: 'openid profile email',
      grant_type: 'authorization_code'
    })
  }) );

const reqTokenGrantRefreshPOST = async ( opts, refresh_token ) => (
  fetchNormal( ( await reqOpenIdConfigGET( opts ) ).token_endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    ...( opts.credentials && { credentials: opts.credentials }),
    body: JSON.stringify({
      refresh_token,
      client_id: opts.client_id,
      grant_type: 'refresh_token'
    })
  }) );

const reqRevokeTokenPOST = async opts => (
  fetchNormal( ( await reqOpenIdConfigGET( opts ) ).revocation_endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    ...( opts.credentials && { credentials: opts.credentials }),
    body: '{}'
  }) );

const reqUserinfoGET = async opts => (
  fetchNormal( ( await reqOpenIdConfigGET( opts ) ).userinfo_endpoint, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' }
  }) );

export {
  reqOpenIdConfigGET,
  reqRevokeTokenPOST,
  reqTokenGrantAuthCodePOST,
  reqTokenGrantRefreshPOST,
  reqUserinfoGET
}
